// extracted by mini-css-extract-plugin
module.exports = {"main":"Header_main__2JQMc"};